<template>
  <div>
    <TitleCard style="max-width: 97%; margin: 10px auto" title="提现管理">
      <template v-slot:subTitle>
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item text-muted">Withdrawal Management</li>
        </ul>
      </template>
    </TitleCard>

    <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
      <div class="d-flex flex-column flex-column-fluid">
        <div id="kt_app_content" class="" style="margin-bottom: 10px;padding: 0px 30px;">
          <div class="card card-flush" style="position: relative">
            <div class="card-body">
              <div>
                <el-input v-model="listParams.name"
                          placeholder="提现姓名"
                          size="small"
                          clearable
                          style="width: 10%;margin-left: 5px"
                ></el-input>
                <el-input v-model="listParams.userId"
                          placeholder="提现会员ID"
                          size="small"
                          clearable
                          style="width: 10%;margin-left: 5px"
                ></el-input>
                <el-select v-model="listParams.status"
                           placeholder="请选择状态"
                           size="small"
                           clearable
                           style="width: 10%;margin-left: 5px"
                >
                  <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                <el-date-picker
                    clearable
                    v-model="dateValue"
                    end-placeholder="结束日期"
                    range-separator="至"
                    size="small"
                    start-placeholder="开始日期"
                    style="width: 23%;margin-left: 5px"
                    type="daterange"
                >
                </el-date-picker>
                <el-button round
                           size="small"
                           style="margin-left: 10px"
                           type="primary"
                           @click="getWithdrawalPageList"
                >查 询
                </el-button>
                <el-button round
                           size="small"
                           style="margin-left: 10px"
                           @click="clearParams"
                >重 置
                </el-button>
              </div>
              <div style="display: flex;align-items: center; margin: 20px;">
                <div>类型 :</div>
                <el-radio-group v-model="listParams.type" style="margin-left: 20px" @input="getWithdrawalPageList">
                  <el-radio label="1">普通用户</el-radio>
                  <el-radio label="2">供应链</el-radio>
                  <el-radio label="3">合伙人</el-radio>
                </el-radio-group>

                <div v-if="listParams.type == 1" style="margin-left: 40px; font-size: 20px; color: red;">
                    灵工账户余额：{{balance}}
                </div>
              </div>
              <el-table
                  :data="tableData"
                  style="width: 100%">
                <el-table-column
                    label="编号"
                    prop="id"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="会员ID"
                    prop="userId"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="提现名称"
                    prop="name"
                    width="200">
                </el-table-column>
                <el-table-column
                    label="银行名称"
                    prop="bankName">
                </el-table-column>
                <el-table-column
                    label="收款账号"
                    prop="cardNo">
                </el-table-column>
                <el-table-column
                    label="申请提现金额">
                  <template #default="scope">
                    {{ scope.row.applyAmount | format }}
                  </template>
                </el-table-column>
                <el-table-column
                    label="打款金额">
                  <template #default="scope">
                    {{ scope.row.amount | format }}
                  </template>
                </el-table-column>
                <el-table-column
                    label="手续费">
                  <template #default="scope">
                    {{ scope.row.withdrawalFee | format }}
                  </template>
                </el-table-column>
                <el-table-column
                    label="手续费比例">
                  <template #default="scope">
                    {{ scope.row.withdrawalFeeRate * 100 + '%' }}
                  </template>
                </el-table-column>
                <el-table-column
                    label="发票">
                  <template #default="scope">
                      <el-image v-if="scope.row.type == 3" style="width: 40px;height: 30px;" :src="scope.row.invoiceUrl" :preview-src-list="[scope.row.invoiceUrl]"></el-image>
                      <el-button v-else-if="scope.row.type == 2 && scope.row.invoiceUrl" @click="downloadInvoice(scope.row.invoiceUrl)" size="mini" type="primary">点击下载</el-button>
                      <el-button v-else disabled  size="mini"  type="info">暂无数据</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                    label="审核状态"
                    prop="statusName">
                  <template #default="scope" >
                    <el-tag v-if="scope.row.status == 0">{{scope.row.statusName}}</el-tag>
                    <el-tag v-else-if="scope.row.status == 1" type="success">{{scope.row.statusName}}</el-tag>
                    <el-tooltip v-else-if="scope.row.status == 2 || scope.row.status == 4" effect="dark" :content="scope.row.auditRemark" placement="top">
                      <el-tag type="danger">{{scope.row.statusName}}</el-tag>
                    </el-tooltip>
                    <el-tag v-else-if="scope.row.status == 3" type="primary">{{scope.row.statusName}}</el-tag>
                    <el-tag v-else type="warning">{{scope.row.statusName}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    label="提现类型"
                    prop="withdrawalAmountTypeName">
                  <template #default="scope" >
                    <el-tag v-if="scope.row.withdrawalAmountType == 1" type="primary">{{scope.row.withdrawalAmountTypeName}}</el-tag>
                    <el-tag v-else-if="scope.row.withdrawalAmountType == 2" type="success">{{scope.row.withdrawalAmountTypeName}}</el-tag>
                    <el-tag v-else-if="scope.row.withdrawalAmountType == 3" type="primary">{{scope.row.withdrawalAmountTypeName}}</el-tag>
                    <el-tag v-else-if="scope.row.withdrawalAmountType == 4" type="primary">{{scope.row.withdrawalAmountTypeName}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    label="打款方式"
                    prop="withdrawalTypeName">
                  <template #default="scope" >
                    <el-tag v-if="scope.row.withdrawalType == 0" type="primary">{{scope.row.withdrawalTypeName}}</el-tag>
                    <el-tag v-else-if="scope.row.withdrawalType == 1" type="success">{{scope.row.withdrawalTypeName}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                    label="提现申请时间"
                    prop="createTime">
                </el-table-column>
                <el-table-column
                    label="审核时间"
                    prop="auditTime">
                </el-table-column>
                <el-table-column
                    label="打款时间"
                    prop="paymentTime">
                </el-table-column>
                <el-table-column width="160"
                    label="操作">
                  <template #default="scope">
                    <el-button
                        v-if="scope.row.status == 0 && scope.row.withdrawalType == 1"
                        size="mini"
                        type="success"
                        @click="pass(scope.row.id)"
                    >通过
                    </el-button>
                    <el-button
                        v-if="(scope.row.status == 0 || scope.row.status == 4) && scope.row.withdrawalType == 0"
                        size="mini"
                        type="success"
                        @click="pass(scope.row.id)"
                    >打款
                    </el-button>
                    <el-button
                        v-if="scope.row.status == 0 || scope.row.status == 4"
                        size="mini"
                        type="danger"
                        @click="showReject(scope.row.id, scope.row.auditRemark)"
                    >拒绝
                    </el-button>
                    <el-button
                        v-if="scope.row.status == 3 && scope.row.withdrawalType == 0"
                        size="mini"
                        type="primary"
                        @click="searchResult(scope.row.id)"
                    >查询打款结果
                    </el-button>
                    <el-button
                        v-if="scope.row.status == 0 && scope.row.type == 2"
                        size="mini"
                        type="success"
                        @click="openOrders(scope.row.bindOrderNoJson)"
                    >查看订单
                    </el-button>

                  </template>
                </el-table-column>
              </el-table>
              <div style="display: flex;justify-content: center;margin-top: 20px">
                <el-pagination
                    :current-page="listParams.current"
                    :page-size="listParams.size"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="tableDataTotal"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="商家提现订单号" :visible.sync="withdrawVisible" width="50%">
      <el-table :data="orders">
        <el-table-column label="订单号">
          <template slot-scope="scope">
            {{scope.row}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="拒绝" :visible.sync="showRejectVisible" width="50%">
      <el-input type="textarea" v-model="rejectReason" placeholder="请输入拒绝理由" autocomplete="off"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRejectDialog">取 消</el-button>
        <el-button type="primary" @click="reject">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mixins} from "@/views/withdrawalApplication/mixins";

export default {
  name: "withdrawalApplication",
  mixins: [mixins],
}
</script>

<style scoped>

</style>
